import React, { Component } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button, Container } from "reactstrap";
import Loader from "../../components/Common/Loader";
//Import form component to render
import CreateUserForm from "../../components/Forms/CreateUserForm";
import "../Tables/datatables.scss";





class CreateUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
    };
  }
goBack(event){
  event.preventDefault()
  this.props.history.push("/users")
}
  render() {
    let user = this.state.user;
    if (!user) {
      return (
        <React.Fragment>
        <div className="loaderCenter">
        <Loader></Loader>
        </div>
 
      </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <div className="user-management">
          <Container fluid>
            {/* Render Breadcrumbs */}
{/*             <Breadcrumbs
              title={this.props.t("Crear usuario")}
              breadcrumbItem={this.props.t("Formulario de creación de ususario")}
            /> */}
            <Button onClick={(event)=>this.goBack(event)} className="btn btn-primary waves-effect waves-light buttonStatus usersButtons">
         
                     {this.props.t("Atrás")}
        
            </Button>
            <CreateUserForm />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateProps = (state) => {
  return {  };
};
export default withRouter(
  connect(mapStateProps, {})(withNamespaces()(CreateUser))
);
